var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgListNumber = function SvgListNumber(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    fill: "none",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A1A1AA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.334 4.668V1.172c-.451.11-.796.42-1 .83m2.333 8.667H1.406v-.334c.588-.412 1.19-.8 1.673-1.34.322-.361.357-.901.01-1.264-.281-.294-.769-.39-1.145-.244-.253.098-.398.296-.538.515m11.595-6H6.334m6.667 4H6.334m6.667 4H6.334"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgListNumber);
export default ForwardRef;